/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Closed_Caption_EmbedInputs */



/**
* | output |
* | --- |
* | "Closed Caption Embed" |
*
* @param {Closed_Caption_EmbedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const closed_caption_embed = /** @type {((inputs?: Closed_Caption_EmbedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Closed_Caption_EmbedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Intégration de sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel einbetten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incorpora sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Встроить субтитры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Incrustar subtítulos cerrados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("隐藏式字幕嵌入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クローズドキャプションの埋め込み")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बंद कैप्शन एम्बेड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incorporar legendas")
	return /** @type {LocalizedString} */ ("Closed Caption Embed")
});